import {EditorSDK} from '@wix/platform-editor-sdk';
import {WIX_ECOM} from '@wix/app-definition-ids';

async function getRef(sdk: EditorSDK) {
  const tpaApplicationId = (await sdk.tpa.app.getDataByAppDefId('', WIX_ECOM)).applicationId;
  const ecomComps = await (sdk.document.tpa as any).app.getAllCompsByApplicationId('', tpaApplicationId);
  return ecomComps?.[0].id;
}

export async function freeProductsLegacyFlag(sdk: EditorSDK, allowFreeProducts: boolean = false) {
  const compId = await getRef(sdk);

  if (!compId) {
    throw new Error('cannot find a compId for freeProductsLegacyFlag');
  }

  await (sdk.document.tpa as any).data.set('', {
    compRef: {id: compId, type: 'DESKTOP'},
    key: 'ALLOW_FREE_PRODUCTS',
    value: allowFreeProducts,
    scope: 'APP',
  });
}
